import { SxProps } from '@mui/material';

export const modalRootSx: SxProps = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const trobberContainerSx: SxProps = {
  paddingTop: 4,
  bgcolor: 'background.default',
  borderRadius: 4,
  width: 362,
  height: 186
};

export const modalContainerSx: SxProps = {
  position: 'relative',
  padding: '56px 24px 24px',
  bgcolor: 'background.default',
  borderRadius: 4,
  minWidth: 480
};

export const closeButtonSx: SxProps = {
  position: 'absolute',
  right: 24,
  top: 24,
  color: 'secondary.main',
  width: 42,
  height: 42
};

export const modalHeadSx: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: 4
};

export const modalBodySx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'stretch',
  whiteSpace: 'pre-line',
  gap: 3
};

export const modalFooterSx: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 3,
  paddingTop: 4
};
